(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["portfolio-case-studies"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-bm-work]';

    const setScrollDistance = (image) => {
      const viewport = image.closest('.bm-browser__viewport');
      if (!viewport) return;

      const distance = Math.max(0, image.getBoundingClientRect().height - viewport.getBoundingClientRect().height);
      const duration = Math.min(16, Math.max(6, distance / 90));
      image.style.setProperty('--bm-scroll-distance', `${distance}px`);
      image.style.setProperty('--bm-scroll-duration', `${duration}s`);
    };

    const loadFrame = (frame) => {
      if (!frame || frame.getAttribute('src')) return;
      const source = frame.dataset.src;
      if (source) frame.setAttribute('src', source);
    };

    const initLivePreview = (preview) => {
      const frame = preview.querySelector('[data-bm-live-frame]');
      const deviceButtons = Array.from(preview.querySelectorAll('[data-bm-device]'));
      const media = preview.closest('.bm-case__media');
      const dialog = media ? media.querySelector('[data-bm-live-dialog]') : null;
      const dialogFrame = dialog ? dialog.querySelector('[data-bm-dialog-frame]') : null;
      const openButton = preview.querySelector('[data-bm-open-dialog]');
      const closeButton = dialog ? dialog.querySelector('[data-bm-close-dialog]') : null;

      deviceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const isMobile = button.dataset.bmDevice === 'mobile';
          preview.classList.toggle('is-mobile-view', isMobile);

          deviceButtons.forEach((item) => {
            const isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', String(isActive));
          });
        });
      });

      if ('IntersectionObserver' in window && frame) {
        const frameObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadFrame(frame);
            observer.disconnect();
          });
        }, { rootMargin: '400px 0px', threshold: 0.01 });
        frameObserver.observe(preview);
      } else {
        loadFrame(frame);
      }

      if (openButton && dialog) {
        openButton.addEventListener('click', () => {
          loadFrame(dialogFrame);
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        });
      }

      if (closeButton && dialog) {
        closeButton.addEventListener('click', () => dialog.close());
      }

      if (dialog) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      }
    };

    const initSection = (root) => {
      if (!root || root.dataset.bmReady === 'true') return;
      root.dataset.bmReady = 'true';
      root.classList.add('bm-is-enhanced');

      const images = Array.from(root.querySelectorAll('[data-bm-scroll-image]'));

      images.forEach((image) => {
        if (image.complete) setScrollDistance(image);
        image.addEventListener('load', () => setScrollDistance(image), { once: true });
      });

      root.querySelectorAll('[data-bm-preview]').forEach((preview) => {
        if (preview.hasAttribute('data-bm-live-preview')) {
          initLivePreview(preview);
          return;
        }

        const start = () => preview.classList.add('is-scrolling');
        const stop = () => preview.classList.remove('is-scrolling');
        preview.addEventListener('pointerenter', start);
        preview.addEventListener('pointerleave', stop);
        preview.addEventListener('focusin', start);
        preview.addEventListener('focusout', stop);
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => images.forEach(setScrollDistance));
        resizeObserver.observe(root);
      }

      const revealItems = Array.from(root.querySelectorAll('[data-bm-reveal]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!('IntersectionObserver' in window) || reduceMotion) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      revealItems.forEach((item) => revealObserver.observe(item));
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(rootSelector).forEach(initSection);
      if (scope.matches && scope.matches(rootSelector)) initSection(scope);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest('[data-bm-reveal]');
      if (item) item.classList.add('is-visible');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
